import type { WizardStatus } from '@risksmart-app/domain/src/types/consts/wizard-status';
import type {
  UpdateWizardMutation,
  UpdateWizardMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateWizardDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type UpdateWizardTRPCInput = {
  RiskId: string;
  CurrentStep: number;
  Status?: WizardStatus | null;
};

export const useUpdateWizard = createMutationHook({
  name: 'updateWizard',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.wizard.update.mutationOptions({ onSuccess }),
  mapInput: (
    variables: UpdateWizardMutationVariables
  ): UpdateWizardTRPCInput => {
    const obj = variables.object;

    return {
      RiskId: obj?.RiskId ?? '',
      CurrentStep: obj?.CurrentStep ?? 0,
      Status: obj?.Status,
    };
  },
  invalidate: (trpc) => [
    trpc.frontend.wizard.wizards.queryKey(),
    trpc.frontend.wizard.wizardById.queryKey(),
  ],
  mapResponse: (trpcData: { affectedRows: number }): UpdateWizardMutation => ({
    updateWizardById: {
      __typename: 'GenericMutationOutput',
      affected_rows: trpcData.affectedRows,
    },
  }),
  graphqlDocument: UpdateWizardDocument,
  graphqlVariables: (variables: UpdateWizardMutationVariables) => variables,
  evictFields: ['wizard'],
});
